<div mat-dialog-header>
  <h1><mat-icon>warning</mat-icon>{{ headline }}</h1>
</div>
<div mat-dialog-content class="dialog-container col-12">
  <div class="inner row col-12" [innerHTML]="content"></div>
</div>
<div mat-dialog-actions class="row buttons">
  <button
    type="button"
    mat-raised-button
    color="accent"
    (click)="dialogRef.close('continue')"
  >
    {{ confirm }}
  </button>
  @if (!hideCancel) {
    <button type="button" mat-raised-button (click)="dialogRef.close('cancel')">
      {{ cancel }}
    </button>
  }
</div>
